
interface TCPoint{
    name:string;
    timeValue:number;
}

export class TimeCheckPoints {

    private static timePoints:TCPoint[] = [];

    public static get allTimePoints():TCPoint[] { return this.timePoints;}

    private static findPoint(name:string):TCPoint | undefined{
        for(let i:number = 0; i < this.timePoints.length; i++) if(name == this.timePoints[i].name) return this.timePoints[i]
        return undefined;
    }

    public static setCheckPoint(name:string):void{
        let conf:TCPoint | undefined = this.findPoint(name);
        if(!conf){
            this.timePoints.push({name:name, timeValue: performance.now()});
        }else conf.timeValue = performance.now();
    }

    public static getCheckPointTime(name:string):number{
        let conf:TCPoint | undefined = this.findPoint(name);
        if(!conf){
            return -1;
        }else return (performance.now() - conf.timeValue);
    }

    public static removeCheckPoint(name:string):void{
        this.timePoints = this.timePoints.filter((conf) => { return conf.name != name });
    }
}